import type { KomaRow } from '~/constants/spotPrice'

// 3h 間隔のコマ番号 (1-based): koma 1,7,13,19,25,31,37,43 = 00:00,03:00,…,21:00
const SINGLE_DAY_TICK_KOMA = new Set([1, 7, 13, 19, 25, 31, 37, 43])

/**
 * X 軸に打つ目盛り (design `_xTicks` と同じ規則)。 単日は 3 時間ごと。 複数日は日の
 * 変わり目 (00:00) を、 日数が多いほど間引いて打つ (7 日以内は毎日、 14 日以内は 2 日ごと、
 * それ以上は 12 目盛り前後)。 2 日以内なら日中 (12:00) も打って時刻感を残す。
 */
export function xTicks(rows: KomaRow[], isMultiDay: boolean): string[] {
  if (!isMultiDay) {
    return rows.filter((r) => SINGLE_DAY_TICK_KOMA.has(r.koma)).map((r) => r.x)
  }
  const dates = [...new Set(rows.map((r) => r.date))]
  const days = dates.length
  const everyN = days <= 7 ? 1 : days <= 14 ? 2 : Math.ceil(days / 12)
  const out: string[] = []
  for (const [i, d] of dates.entries()) {
    if (i % everyN !== 0) continue
    out.push(`${d} 00:00`)
    if (days <= 2) out.push(`${d} 12:00`)
  }
  return out
}

/** X 軸キー `YYYY-MM-DD HH:MM` の目盛り表記。 複数日は日の変わり目を `MM/DD` で示す。 */
export function formatTick(x: string, isMultiDay: boolean): string {
  const time = x.slice(11)
  return isMultiDay && time === '00:00'
    ? x.slice(5, 10).replace('-', '/')
    : time
}
